import './App.scss';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import EntrepreneurLoginPage from './Pages/EntrepreneurLoginPage/EntrepreneurLoginPage';
import { Container } from './Layout/Container';
import { Modal } from './Layout/Modal/Modal';
import { Toaster } from './Layout/Toaster/Toaster';
import { OverLayer } from './Layout/OverLayer';
import { Aggreg8UserFlowWindow } from './OuterApi/Aggreg8/Aggreg8UserFlowWindow';
import { ProtectedRoute } from './Authentication/ProtectedRoute';
import { NotFound } from './Layout/NotFound';
import { AuthenticateBankAccountsRoute } from './Authentication/AuthenticateBankAccountsRoute';
import { AuthenticateRoute } from './Authentication/AuthenticateRoute';
import * as React from 'react';
import { RedirectRoute } from './Authentication/RedirectRoute';
import { lazy, Suspense } from 'react';
import { Spinner } from './Layout/Spinner';

const AccountantLoginPage = lazy(() => import('./Pages/AccountantLoginPage'));
const AuthManagementScreen = lazy(() => import('./Pages/AutManagementScreen/AuthManagementScreen'));
const CompaniesPage = lazy(() => import('./Pages/CompaniesPage/CompaniesPage'));
const AccountantsPage = lazy(() => import('./Pages/AccountantsPage/AccountantsPage'));
const BankAccountPage = lazy(() => import('./Pages/BankAccountPage/BankAccountPage'));
const TransactionPage = lazy(() => import('./Pages/TransactionPage/TransactionPage'));
const ExportPage = lazy(() => import('./Pages/ExportPage/ExportPage'));
const CompanyRegistrationPage = lazy(() => import('./Pages/CompanyRegistrationPage/CompanyRegistrationPage'));

const PrivacyPage = lazy(() => import('./Pages/PrivacyPage/PrivacyPage'));
const AccountantNotificationPage = lazy(() => import('./Pages/PrivacyPage/AccountantNotification'));
const EntrepreneurNotificationPage = lazy(() => import('./Pages/PrivacyPage/EntrepreneurNotification'));
const AccountantPrivacy = lazy(() => import('./Pages/PrivacyPage/AccountantPrivacy'));
const EntrepreneurPrivacy = lazy(() => import('./Pages/PrivacyPage/EntrepreneurPrivacy'));
export default function App() {
  return (
    <Router>
      <Container>
        <Modal />
        <Toaster />
        <OverLayer />
        <Aggreg8UserFlowWindow />
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route path="/konyvelo-hirdetmenyek" element={<AccountantNotificationPage />} />
            <Route path="/vallalkozo-hirdetmenyek" element={<EntrepreneurNotificationPage />} />
            <Route path="/konyvelo-aszf" element={<AccountantPrivacy />} />
            <Route path="/vallalkozo-aszf" element={<EntrepreneurPrivacy />} />
            <Route path="/" element={<EntrepreneurLoginPage />} />
            <Route path="/login" element={<AccountantLoginPage />} />
            <Route path={`/bankaccounts/:token/:taxNumber`} element={<AuthenticateBankAccountsRoute />} />
            <Route path={`/companies/:token`} element={<AuthenticateRoute />} />
            <Route path={`/privacy`} element={<PrivacyPage />} />
            <Route path={`/transaction-viewer/:token/:taxNumber`} element={<AuthenticateRoute />} />
            <Route path={`/registration/confirm/:token/`} element={<AuthenticateRoute />} />
            <Route path={`/`} element={<RedirectRoute />}>
              <Route path={`token-management`} element={<AuthManagementScreen />} />
              <Route path={`companies`} element={<CompaniesPage />} />
              <Route path={`companies/accountants`} element={<AccountantsPage />} />
              <Route path={`bankaccounts`} element={<BankAccountPage />} />
              <Route path={`transaction-viewer`} element={<TransactionPage />} />
              <Route path={`exports`} element={<ExportPage />} />
            </Route>
            <Route path={`/`} element={<ProtectedRoute />}>
              <Route path={`confirm`} element={<CompanyRegistrationPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Container>
    </Router>
  );
}
